import React from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import { Checkbox } from 'rmwc/Checkbox';
import { Theme } from 'rmwc/Theme';
import {
  Card,
  CardMedia,
  CardPrimary,
  CardTitle,
  CardSubtitle,
  CardSupportingText,
  CardActions,
  CardAction,
} from 'rmwc/Card';
import {
  GridList,
  GridTile,
  GridTilePrimary,
  GridTilePrimaryContent,
  GridTileSecondary,
  GridTileTitle,
} from 'rmwc/GridList';
import { Typography } from 'rmwc/Typography';
import { Text } from '../Text';

const Choice = ({ key, option, label, description, image, checked, onChange, disabled }) => (
  <GridTile key={key}>
    <GridTilePrimary>
      <GridTilePrimaryContent>
        <div style={{ backgroundImage: `url(${image})` }} />
      </GridTilePrimaryContent>
    </GridTilePrimary>
    <GridTileSecondary>
      <div className="hrbr-grid-control">
        <Checkbox
          id={option}
          checked={checked}
          disabled={disabled}
          onChange={evt => onChange(option, evt.target.checked)}
        >
          <div className="mdc-grid-tile__title">
            <Theme use="on-primary">{label}</Theme>
          </div>
        </Checkbox>
      </div>
      <div className="hrbr-grid-caption">
        <Theme use="on-primary">{description}</Theme>
      </div>
    </GridTileSecondary>
  </GridTile>
);

export const MultipleChoiceControl = ({ values, options, option_data, max_selections, onChange, style }) => {
  const choice = option => (
    <Choice
      key={`opt-${option}`}
      option={option}
      onChange={onChange}
      checked={includes(values, option)}
      disabled={!includes(values, option) && values.length >= max_selections}
      {...option_data[option]}
    />
  );

  return <GridList style={{ display: 'flex', justifyContent: 'flex-start' }}>{options.map(choice)}</GridList>;
};

MultipleChoiceControl.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.string),
  option_data: PropTypes.object,
  onChange: PropTypes.func,
};
